import { createFileRoute } from "@tanstack/react-router"
import { OnboardingPage } from "@/app"

export const Route = createFileRoute("/(user)/onboarding")({
  component: RouteComponent,
})

function RouteComponent() {
  return <OnboardingPage />
}
